import ApiService, { HttpMethod } from "../../commons/api/api_service";
import BaseResponse from "../../commons/api/base_response";
import { Endpoints } from "../../commons/api/endpoints";
import { ProviderVM } from "../../commons/base/providers/view_model";
import { ShowSnackbarModel } from "../../commons/scaffold/scaffold";
import { FinishCookingOrderModel } from "../models/finish_cooking_order_model";

export default class FinishCookingDashboardViewModel extends ProviderVM {
    ordersMap: Map<number, FinishCookingOrderModel> = new Map<
        number,
        FinishCookingOrderModel
    >();
    isSubmitting: boolean = false;
    snackBar?: ShowSnackbarModel;

    constructor() {
        super();
        this.fetchData();
    }

    fetchData() {
        ApiService.fetch(Endpoints.getFinishCookingOrderList, {
            httpMethod: HttpMethod.post,

            onSuccess: (response: BaseResponse<FinishCookingOrderModel[]>) => {
                if (response.code === 200) {
                    const orders = response.data as FinishCookingOrderModel[];

                    const ordersMap = new Map<
                        number,
                        FinishCookingOrderModel
                    >();
                    orders.forEach((order) => {
                        ordersMap.set(order.id, order);
                    });

                    this.emit(() => {
                        this.ordersMap = ordersMap;
                    });

                    setTimeout(() => {
                        this.fetchData();
                    }, 20000);
                } else {
                    this.emit(() => {
                        this.snackBar = {
                            key: Date.now().toString(),
                            message: response.message,
                            type: "error",
                        };
                    });
                }
            },
            onFailure: (errorMessage) => {
                this.emit(() => {
                    this.snackBar = {
                        key: Date.now().toString(),
                        message: errorMessage,
                        type: "error",
                    };
                });
            },
        });
    }

    tickOrder(args: { orderId: number; isNotDone: boolean }) {
        this.emit(() => {
            this.isSubmitting = true;
        });

        ApiService.fetch(Endpoints.updateFinishCookingOrder, {
            httpMethod: HttpMethod.post,
            parameters: {
                id: args.orderId,
                is_not_done: args.isNotDone,
            },
            onSuccess: (response: BaseResponse<{}>) => {
                if (response.code === 200) {
                    const updatedOrdersMap = new Map(this.ordersMap);
                    updatedOrdersMap.delete(args.orderId);

                    this.emit(() => {
                        this.snackBar = {
                            key: Date.now().toString(),
                            message: "Berhasil update order!",
                            type: "normal",
                        };
                        this.isSubmitting = false;
                        this.ordersMap = updatedOrdersMap;
                    });
                } else {
                    this.emit(() => {
                        this.snackBar = {
                            key: Date.now().toString(),
                            message: response.message,
                            type: "error",
                        };
                        this.isSubmitting = false;
                    });
                }
            },
            onFailure: (errorMessage) => {
                this.emit(() => {
                    this.snackBar = {
                        key: Date.now().toString(),
                        message: errorMessage,
                        type: "error",
                    };
                    this.isSubmitting = false;
                });
            },
        });
    }
}
